<template>
  <div class="flex flex-col mx-auto">
    <HeaderBar :simple="true" :showLogin="false" :showSignup="false"></HeaderBar>
    <AppMain class="bg-[#f6f5ff00]"></AppMain>
  </div>
</template>

<script>
import {AppMain, HeaderBar} from './components'
export default {
  name: 'SimpleLayout',
  components: {AppMain, HeaderBar},
  data() {
    return {
      showLogin: true,
      showSignup: true
     }
  },
  provide() {
    return {
      updateButtons: this.updateButtons
    }
  },
  methods: {
    updateButtons: function(showLogin, showSignup = true) {
      this.showLogin = showLogin;
      this.showSignup = showSignup;
    }
  }
}
</script>
